import { ReactNode } from 'react';
import styles from './ProMetric.module.css';

export type ProMetricVariant = 'default' | 'green' | 'orange';

interface ProMetricProps {
  eyebrow: string;
  value: string | number;
  sub?: string;
  variant?: ProMetricVariant;
}

export function ProMetric({ eyebrow, value, sub, variant = 'default' }: ProMetricProps) {
  return (
    <div className={`${styles.tile} ${styles[`v_${variant}`]}`}>
      <div className={styles.eyebrow}>{eyebrow}</div>
      <div className={`${styles.value} tnum`}>{value}</div>
      {sub && <div className={styles.sub}>{sub}</div>}
    </div>
  );
}

interface ProMetricStripProps {
  children: ReactNode;
}

export function ProMetricStrip({ children }: ProMetricStripProps) {
  return <div className={styles.strip}>{children}</div>;
}
